import { motion } from "framer-motion";
import { Ticket } from "lucide-react";

const LAUNCH_DATE = new Date("2026-08-16T00:00:00Z");

const dailyBatch = (dayIndex) => {
  const x = Math.sin(dayIndex * 9301 + 49297) * 233280;
  return 180 + Math.floor((x - Math.floor(x)) * 41);
};

const entryCount = () => {
  const days = Math.max(0, Math.floor((Date.now() - LAUNCH_DATE) / 86400000));
  let total = 1400;
  for (let d = 1; d <= days; d++) total += dailyBatch(d);
  return total;
};

export const EntryCounter = () => {
  const count = entryCount();
  return (
    <motion.div
      data-testid="entry-counter"
      className="relative mt-5 flex items-center gap-2.5 self-center rounded-full border-2 border-yellow-400 bg-white px-4 py-2.5 shadow-[0_0_16px_rgba(234,179,8,0.4)]"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.75 }}
    >
      <Ticket size={16} className="text-pink-500" />
      <span className="font-display text-sm font-black text-slate-900 tabular-nums">
        <span data-testid="entry-counter-value" className="inline-block">
          {count.toLocaleString()}
        </span>{" "}
        <span className="font-bold text-slate-500">entries earned so far!</span>
      </span>
    </motion.div>
  );
};
